import React from "react";
import { useTheme } from "../../../ThemeContext";

const DropLogo = ({ eventUrl, artistUrl }) => {
  const { darkMode } = useTheme();

  const renderLogo = () => {
    switch (true) {
      case artistUrl !== null:
        return (
          <div
            style={{
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "13.48px",
              }}
              alt="artistLogo"
              src={artistUrl}
            />
          </div>
        );

      case eventUrl.includes("ticketmaster"):
        return (
          <div
            style={{
              background: "#026CDF",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #004998",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <img
              alt="tmLogo"
              src="DropLogos/tm.png"
              style={{
                width: "65px",
                height: "65.13px",
                color: "white",
                fill: "white",
                stroke: "white",
                filter: "brightness(0) invert(1)",
              }}
            />
          </div>
        );
      case eventUrl.includes("livenation"):
        return (
          <div
            style={{
              background: "#E41D39",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #9B1326",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <svg
              width="62"
              height="43"
              viewBox="0 0 62 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 10H8.32186V30.7108H20V39H0V10Z" fill="white" />
              <path
                d="M37 10H44.8231L53.7198 22.8025V10H62V39H54.5914L45.3227 25.6296V39H37.0425V10H37.0106H37Z"
                fill="black"
              />
              <path
                d="M39.9919 1.49621C39.9919 1.49621 39.339 0.353568 39.2109 0.122473C39.0829 -0.108623 38.8908 0.0582754 38.8908 0.0582754C38.8908 0.0582754 38.2379 0.546151 37.8794 0.777247C37.5209 1.00834 37.5593 1.30362 37.5593 1.43201C37.5593 1.59891 37.4569 2.47195 37.4569 2.47195C37.4185 2.66453 37.3288 2.83143 37.2648 2.93414L31.4906 7.42767L30.7736 7.59457L28.9939 8.4676L29.0964 7.26076C29.2244 7.32495 29.4164 7.51754 29.5573 7.55605C29.7237 7.59457 29.9798 7.51754 29.9798 7.51754C29.9798 7.51754 29.8774 7.28644 29.8774 7.15806C29.8774 7.02967 29.9158 6.79857 29.9158 6.79857C29.9158 6.79857 30.1718 6.96548 30.4023 6.96548C30.5687 6.96548 30.7224 6.90128 30.8248 6.83709C30.9272 6.7729 31.0168 6.64451 31.0168 6.64451C31.0168 6.64451 30.6968 6.45193 30.5559 6.32354C30.4919 6.22083 30.3639 6.09245 30.4279 6.09245C30.5943 6.09245 30.8504 5.86135 30.8504 5.86135C30.8504 5.86135 30.684 5.75864 30.5303 5.63026C30.3767 5.50187 30.2999 5.39916 30.2358 5.24509C30.1718 5.09103 30.1334 4.94981 30.1334 4.94981C30.1334 4.94981 30.2359 5.07819 30.4535 5.07819C30.6456 5.07819 30.8376 4.94981 30.8376 4.94981C30.8376 4.94981 30.6712 4.8471 30.5815 4.75723C30.4791 4.62884 30.3895 4.50045 30.3255 4.33355C30.2615 4.10245 30.223 3.97407 30.159 3.80717C30.1206 3.70446 30.1206 3.57607 30.0566 3.34498C29.9926 2.81859 29.7621 2.60033 29.7621 2.60033C29.0836 1.68879 27.5216 1.45769 27.5216 1.45769C26.7406 1.29079 25.934 2.33072 25.6011 3.38349C25.0761 5.10387 25.2426 6.79857 25.2426 6.79857C25.2426 6.79857 25.281 7.11954 25.5371 7.28644C25.7035 7.38915 26.3821 7.54321 26.3821 7.54321L26.3181 8.94263L24.6664 9.07101C24.6664 9.07101 23.4373 8.32637 22.3875 7.69728L17.8039 4.28219C17.8039 4.28219 17.6119 4.15381 17.5734 3.79433C17.5734 3.79433 17.471 2.9213 17.471 2.7544C17.471 2.5875 17.5094 2.33072 17.1509 2.09963C16.7925 1.86853 16.1395 1.38066 16.1395 1.38066C16.1395 1.38066 15.909 1.18808 15.781 1.41918C15.653 1.65027 15 2.79291 15 2.79291L15.3201 4.08962C15.3201 4.08962 15.4481 4.34639 15.6786 4.57749L15.973 4.87277L17.6631 6.40057H17.7015L20.4926 8.90411L21.2992 9.68726C21.2992 9.68726 21.3632 9.78998 21.3632 9.94404V10.5603C21.3632 10.5603 21.3632 10.6887 21.4272 10.7914C21.5297 10.8941 23.0148 12.0881 23.0148 12.0881C23.0148 12.0881 23.1173 12.1908 23.1173 12.3834L23.3733 21.3704C23.3733 21.3704 23.3733 21.4988 23.5013 21.4988L23.9879 21.6914L25.0889 31.5258L27.2015 38.035L23.8598 39.6655C23.8598 39.6655 23.7318 39.7297 23.6678 39.8581C23.6678 39.8581 23.4757 40.2433 23.4757 40.3203C23.4757 40.4487 23.5782 40.4872 23.5782 40.4872H28.5458L28.0593 41.7839L27.9313 42.1434C27.9313 42.1434 27.7648 42.7982 28.0337 42.888C28.3282 42.9907 29.1988 43.0164 29.5957 42.9907C30.0822 42.9522 30.9656 42.888 31.1193 42.7596C31.2473 42.6312 31.3113 42.015 30.5943 38.035L30.1718 22.6671L31.4394 13.0253C31.5674 11.9469 31.6954 11.857 31.6954 11.857C31.6954 11.857 33.0654 10.8427 33.1934 10.7144C33.3214 10.586 33.2958 10.3934 33.2958 10.3934V9.31495C33.2958 9.12237 33.3598 8.95546 33.3598 8.95546L34.4609 7.87702L34.781 7.55605L38.2891 4.16665L38.9036 3.44769L39.1981 3.15239C39.3902 2.9213 39.5182 2.66453 39.5182 2.66453C39.5182 2.66453 39.7743 2.00975 39.8767 1.81717C40.0687 1.68879 39.9791 1.45769 39.9791 1.45769"
                fill="black"
              />
            </svg>
          </div>
        );

      case eventUrl.includes("evenue.net"):
        return (
          <div
            style={{
              background: "#EA0C2A",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #B00C22",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <img
              alt="evenue"
              src="DropLogos/evenue.png"
              style={{
                width: "69.02px",
                height: "24.95px",
              }}
            />
          </div>
        );

      case eventUrl.includes("stubhub"):
        return (
          <div
            style={{
              background: "#3F1D74",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #301855",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <img
              alt="shLogo"
              src="DropLogos/sh-drop.png"
              style={{
                width: "39.79px",
                height: "42px",
              }}
            />
          </div>
        );

      case eventUrl.includes("tickets.com"):
        return (
          <div
            style={{
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              //   border: "1.35px solid #C4421E",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            {darkMode ? (
              <img alt="mlbLogo" src="DropLogos/mlb-drop.png" />
            ) : (
              <img alt="mlbLogo" src="DropLogos/mlb-drop-light.png" />
            )}
          </div>
        );

      case eventUrl.includes("seatgeek"):
        return (
          <div
            style={{
              background: "#FF5B49",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #BF4336",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <svg
              width="50"
              height="34"
              viewBox="0 0 50 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M37.8321 19.8207L42.8782 19.5547V26.377C35.309 27.0991 32.1955 24.4386 32.1955 16.4761C32.1955 9.10272 37.8142 7.25937 43.0034 7.25937C47.5664 7.25937 50 7.79147 50 7.79147L48.6222 0.133022C47.4233 0.0760109 45.276 0 41.6614 0C33.287 0 24 4.2568 24 17.7303C24 29.0755 31.3008 34.8336 40.552 33.9024C47.0654 33.2563 50 33.1043 50 33.1043V13.3975L39.1204 13.6636L37.8321 19.8207Z"
                fill="black"
              />
              <path
                d="M8.02353 9.19165C8.02353 5.36938 16.3059 6.40685 20.1143 8.62741L20.4655 1.09208C19.5597 0.819058 15.8992 0 11.5546 0C5.37983 0 0 3.58565 0 9.30086C0 19.4754 14.1059 20.1852 14.1059 24.2623C14.1059 29.6317 4.75126 26.6467 0 22.2238V30.7966C0 30.7966 3.49412 34 10.4454 34C18.0992 34 22 29.0857 22 23.7891C22 13.4507 8.02353 13.4143 8.02353 9.19165Z"
                fill="black"
              />
            </svg>
          </div>
        );
      case eventUrl.includes("axs"):
        return (
          <div
            style={{
              background: "#1D549D",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #143C71",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <div
              style={{
                marginTop: "3px",
              }}
            >
              <svg
                width="85"
                height="50"
                viewBox="0 0 70 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1860_199)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M63.7735 10.4153C62.5033 10.0844 60.9958 9.74544 59.7269 9.40605C59.4732 9.33822 56.5494 8.61232 56.5494 6.9171C56.5494 4.99724 58.9337 4.70116 60.5471 4.70116C62.5355 4.70116 65.0819 5.456 65.8281 5.76762C66.5741 6.07923 66.866 5.82468 67.2404 5.38187L69.5728 2.62227C69.7155 2.4533 69.7131 2.0764 69.3162 1.90329C69.3162 1.90329 65.0414 0.0337801 60.7333 0.0337801C58.5178 0.0337801 56.6738 0.184029 54.8598 0.941351C53.065 1.69156 50.5333 3.52625 50.5333 7.3358C50.5333 12.4578 54.4169 13.6932 56.3031 14.2527C57.7509 14.6827 61.8806 15.3949 63.0317 16.2267C63.8674 16.8306 64.1207 17.7859 63.9343 18.6961C63.7153 19.7646 62.4814 20.6928 59.5288 20.6928C57.1689 20.6928 55.6442 20.1088 53.3427 18.9842C52.7467 18.6929 52.6684 18.6892 52.3111 19.1049L49.8879 21.9246C49.5212 22.3513 49.2568 22.687 49.8632 23.0365C51.0185 23.7024 55.9471 25.7121 60.1936 25.7121C64.9623 25.7121 70 23.8703 70 17.7805C70 14.8427 68.8881 11.7475 63.7735 10.4153ZM14.3723 19.0573C13.4427 20.3124 12.1337 20.9402 10.4462 20.9402C9.32631 20.9402 8.43934 20.6176 7.78526 19.9722C7.13195 19.3263 6.80428 18.4588 6.80428 17.368C6.80428 15.9039 7.27692 14.8712 8.22248 14.2685C9.16692 13.6666 12.1729 13.4425 12.1729 13.4425C12.7467 13.3993 13.6877 13.3644 14.2627 13.3644H14.7219C15.2973 13.3644 15.7676 13.4981 15.7676 13.9887C15.7676 15.902 15.3019 17.8021 14.3723 19.0574M11.3408 0C6.32877 0 2.97437 1.42581 2.23881 1.73473C1.77037 1.93147 1.79753 2.30554 1.94012 2.47437L4.27252 5.23411C4.78793 5.84367 5.08522 5.82875 5.56626 5.66317C5.57956 5.65861 7.92834 4.67014 11.3408 4.67014C12.7943 4.67014 13.8906 4.93969 14.6448 5.45579C15.6651 6.15412 15.6836 7.3559 15.7565 8.07917C15.8053 8.563 15.2973 8.82371 14.7219 8.82371H11.3408C7.47327 8.82371 4.61559 9.49475 2.76976 10.8357C0.92351 12.1774 0 14.2543 0 17.0661C0 19.6642 0.77399 21.6867 2.32267 23.1358C3.87135 24.5849 6.08797 25.31 8.81111 25.31C11.5508 25.31 13.8333 24.3667 15.7655 21.9703C16.2569 21.3609 16.5854 21.8694 16.5854 21.8694L18.7566 24.3881C18.7566 24.3881 18.7718 24.4069 18.8011 24.4349C18.8879 24.5184 19.101 24.6864 19.4116 24.6864H21.5207C21.8889 24.6864 22.1096 24.4919 22.1137 24.2141V10.9329C22.1137 6.8293 21.3112 3.98149 19.7032 2.38781C18.0975 0.796491 15.3095 0 11.3408 0ZM50.8686 1.02439C51.1958 0.643203 51.0504 0.334554 50.5459 0.334554H39.9179C39.5389 0.334554 39.0895 0.60659 38.9176 0.939762L38.0778 2.5925L41.4327 12.0039L50.8687 1.02432L50.8686 1.02439ZM48.3593 29.3522L33.7664 1.14148C33.5373 0.697223 32.9384 0.334485 32.432 0.334485H21.9538C21.4497 0.334485 21.3031 0.643134 21.6311 1.02432L31.7458 12.9913L26.1641 23.8975C25.9362 24.3424 26.1641 24.7074 26.6687 24.7074L29.6374 24.7071C30.0506 24.7071 30.2915 24.4096 30.2915 24.4096L35.8935 17.8984L45.5684 29.3532C45.5721 29.3576 46.099 30 46.6931 30H47.9702C48.1405 30 48.6971 30.0051 48.3595 29.3524L48.3593 29.3522Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1860_199">
                    <rect width="70" height="30" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        );

      default:
        return (
          <div
            style={{
              background: "#026CDF",
              width: "123px",
              height: "85px",
              top: "254px",
              left: "190px",
              gap: "0px",
              borderRadius: "13.48px",
              border: "1.35px solid #004998",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <img
              alt="tmLogo"
              src="DropLogos/tm-drop.png"
              style={{
                width: "56px",
                height: "36.13px",
              }}
            />
          </div>
        );
    }
  };

  return renderLogo();
};

export default DropLogo;
